import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import useSubmittedProposals from '../../hooks/useSubmittedProposals'
import { downloadZipFile } from './utils/fileDownload'

function getMaterialDownloadUrls(data) {
  if (!Array.isArray(data)) {
    return []
  }
  return data.flatMap(doc => {
    const views = [
      {
        downloadUrl: doc.aerialView.downloadUrl,
        fileName: doc.aerialView.fileName
      },
      { downloadUrl: doc.view1.downloadUrl, fileName: doc.view1.fileName },
      { downloadUrl: doc.view2.downloadUrl, fileName: doc.view2.fileName }
    ]
    return views.map(view => ({
      id: doc.id,
      pseudonym: doc.pseudonym,
      downloadUrl: view.downloadUrl,
      fileName: view.fileName
    }))
  })
}

const DownloadViewImages = ({ setLoading, setError }) => {
  const { imagesData } = useSubmittedProposals()
  const { t } = useTranslation('proposals')
  const urls = getMaterialDownloadUrls(imagesData)

  const handleDownload = () => {
    downloadZipFile('Images.zip', urls, setLoading, setError)
  }

  return <Wrapper onClick={handleDownload}>{t('View images')}</Wrapper>
}

export default DownloadViewImages

const Wrapper = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
`
